import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ParticipantType } from '@cds/betting-offer';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { translationToStr } from '@frontend/sports/common/core/utils/translations';
import { WinGameParticipant } from '@frontend/sports/racing/feature/models';
import { orderBy } from 'lodash-es';

@Component({
    selector: 'ms-resulted-greyhounds-non-runner-participants',
    templateUrl: './resulted-greyhounds-non-runner-participants.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultedGreyhoundsNonRunnerParticipantsComponent implements OnInit {
    @Input() participants: WinGameParticipant[];
    @Input() isOptionBet = false;
    @Input() fixtureParticipants: WinGameParticipant[];

    nonrunnterlist: SafeHtml;
    nonRunners: { raceCardNumber: number; name: string }[] = [];

    constructor(
        public sitecore: Sitecore,
        private sanitized: DomSanitizer,
    ) {}

    ngOnInit(): void {
        this.setNonRunners();
    }

    private setNonRunners(): void {
        if (this.isOptionBet) {
            this.nonRunners = orderBy(this.participants, (v) => v.participantId).map((_) => ({
                raceCardNumber:
                    _.properties?.type === ParticipantType.Dog
                        ? this.fixtureParticipants.find((fp) => fp.id === _.properties?.associatedFixtureParticipantId)!.participantId
                        : _.participantId,
                name: _.properties?.greyhound ? _.properties.greyhound : translationToStr(_.name),
            }));
        } else {
            this.nonRunners = orderBy(this.participants, (v) => v.participantId).map((_) => ({
                raceCardNumber: _.participantId,
                name: _.properties!.greyhound,
            }));
        }
        this.nonrunnterlist = this.sanitized.bypassSecurityTrustHtml(this.concate(this.nonRunners));
    }

    private concate(nonRunners: { raceCardNumber: number; name: string }[]): string {
        return nonRunners.map((x) => `${'<b>' + x.raceCardNumber + '</b>' + '&nbsp' + x.name}`).join(',&nbsp');
    }
}
